const author = {
  esp: 'Tatjana Auderskaja'
};

export default author;